import { asSingleStyleConfig } from '../../../../utils/theme';
import { Input } from './input';
export var NumberInput = asSingleStyleConfig({
  variants: Input.variants
});